var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8C20 8 20 12 20 12V14H14V12C14 12 14 10.31 12.85 8.8C12.68 8.57 12.47 8.35 12.25 8.14C12.77 8.06 13.34 8 14 8ZM0 12C0 12 0 8 6 8C12 8 12 12 12 12V14H0V12ZM7 16V18H13V16L16 19L13 22V20H7V22L4 19L7 16ZM6 0C4.34 0 3 1.34 3 3C3 4.66 4.34 6 6 6C7.66 6 9 4.66 9 3C9 1.34 7.66 0 6 0ZM14 0C12.34 0 11 1.34 11 3C11 4.66 12.34 6 14 6C15.66 6 17 4.66 17 3C17 1.34 15.66 0 14 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendors);
export default __webpack_public_path__ + "static/media/vendors.a223fc03cac000e61996f79739bea5a8.svg";
export { ForwardRef as ReactComponent };